module.exports = __webpack_public_path__ + "img/close-icon.23737268.svg";